import React from "react";
export default function useWeakRef(value) {
    const ref = React.useRef(value);
    React.useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref;
}
//# sourceMappingURL=useWeakRef.js.map